import { File } from '@phosphor-icons/react';
import { Inline, LinkButton } from '@etg/wings';
import { useSnowplowTracking, useTranslation } from '@eti/providers';
import { useToggle } from '../../../../../common/custom-hooks/toggle';
import { useScrollToElementViaQueryParams } from '../../../../../common/custom-hooks/scrollToElementViaQueryParams';
import ReceiptPrintDialog from '../../../../receipt/components/modals/ReceiptPrintDialog';
import { SHOW_CREATE_INVOICE } from '../../../constants/general';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';

const Invoice = () => {
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const { addOnOrders, orderNumber, orderReferenceSerialized, purchaseDate } = useOrderDetails();

  const {
    isOpen: isCreateInvoiceDialogOpen,
    handleClose: handleCloseCreateInvoiceDialog,
    handleToggle: handleToggleCreateInvoiceDialog,
  } = useToggle(false);

  useScrollToElementViaQueryParams(
    'create-invoice-button',
    SHOW_CREATE_INVOICE,
    handleToggleCreateInvoiceDialog,
  );

  const handleSnowplowOnCreateInvoice = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Overview',
        action: 'Click',
        label: 'CREATE_INVOICE',
      });
    }
  };

  return (
    <>
      <Inline spacing={4}>
        <File aria-hidden size={20} />
        <LinkButton
          data-testid="create-invoice-button"
          id="create-invoice-button"
          onClick={() => {
            handleToggleCreateInvoiceDialog();
            handleSnowplowOnCreateInvoice();
          }}
        >
          {t('OrderDetails.Payment.Overview.CreateInvoiceButton.Label')}
        </LinkButton>
      </Inline>
      <ReceiptPrintDialog
        addOnOrders={addOnOrders}
        isOpen={isCreateInvoiceDialogOpen}
        onClose={handleCloseCreateInvoiceDialog}
        orderNumber={orderNumber}
        orderReferenceSerialized={orderReferenceSerialized}
        purchaseDate={purchaseDate}
        shouldShowPrintConfirmationButton={false}
      />
    </>
  );
};

export default Invoice;
